import React from "react";
import Button, { ButtonType } from "../../../components/Button/Button";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import Modal from "../../../components/Modal/Modal";
import { Container, StyledInput, Wrapper } from "../../../components/styled/styled-components";
import { useNavigate } from "react-router-dom";

interface Props {
  modalToShow: number;
  activateSavedOrder: (a?: boolean) => void;
  deleteSavedOrder: () => void;
  setModalToShow: React.Dispatch<React.SetStateAction<number>>;
  isLoading: boolean;
  setDraftNote: React.Dispatch<React.SetStateAction<string>>;
}

const ModalSwitcher = (props: Props) => {
  const {
    modalToShow,
    activateSavedOrder,
    deleteSavedOrder,
    setModalToShow,
    isLoading,
    setDraftNote,
  } = props;
  const navigate = useNavigate();

  switch (modalToShow) {
    case 1:
      return (
        <Modal>
          <div className="modal-template">
            <p>There are items in your cart.</p>
            <p>
              <b>To load this order, you must empty your cart or save it.</b>
            </p>
            {isLoading ? (
              <Wrapper margin="1em 0">
                <LoadingSpinner />
              </Wrapper>
            ) : (
              <Container row jcsa margin="1em 0">
                <Button type={ButtonType.danger} onClick={() => activateSavedOrder()}>
                  Empty cart
                </Button>
                <Button type={ButtonType.primary} onClick={() => setModalToShow(2)}>
                  Save cart
                </Button>
                <Button type={ButtonType.secondary} onClick={() => setModalToShow(-1)}>
                  Cancel
                </Button>
              </Container>
            )}
          </div>
        </Modal>
      );
    case 2:
      return (
        <Modal>
          <div className="modal-template">
            <p>Set an order note for the current cart.</p>
            <form>
              <StyledInput
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setDraftNote(event.target.value)
                }
              />
              {isLoading ? (
                <Wrapper margin="1em 0">
                  <LoadingSpinner />
                </Wrapper>
              ) : (
                <Container row jcsa margin="1em 0">
                  <Button
                    className="modal-switcher__button"
                    type={ButtonType.primary}
                    onClick={(event) => {
                      activateSavedOrder(true);
                      event.preventDefault();
                    }}
                  >
                    Save cart and Load Saved Order
                  </Button>
                  <Button type={ButtonType.secondary} onClick={() => setModalToShow(-1)}>
                    Cancel
                  </Button>
                </Container>
              )}
            </form>
          </div>
        </Modal>
      );
    case 3:
      return (
        <Modal>
          <div className="modal-template">
            <p>Are you sure you want to delete this saved order?</p>
            <p>
              <b>This action cannot be undone.</b>
            </p>
            {isLoading ? (
              <Wrapper>
                <LoadingSpinner />
              </Wrapper>
            ) : (
              <Container row jcsa margin="0em 0">
                <Button type={ButtonType.danger} onClick={() => deleteSavedOrder()}>
                  Delete
                </Button>
                <Button type={ButtonType.secondary} onClick={() => setModalToShow(-1)}>
                  Cancel
                </Button>
              </Container>
            )}
          </div>
        </Modal>
      );
    case 4:
      return (
        <Modal>
          <div className="modal-template">
            <p>The order has been successfully loaded</p>
            {isLoading ? (
              <Wrapper>
                <LoadingSpinner />
              </Wrapper>
            ) : (
              <Container row jcsa margin="0em 0">
                <Button type={ButtonType.primary} onClick={() => navigate("/store/cart")}>
                  Go to Cart
                </Button>
              </Container>
            )}
          </div>
        </Modal>
      );
    case 5:
      return (
        <Modal>
          <div className="modal-template">
            <p>
              You have reached the max limit of 30 saved orders. Please delete some saved orders
            </p>
            <Container row jcsa margin="0em 0">
              <Button type={ButtonType.primary} onClick={() => window.location.reload()}>
                Refresh page
              </Button>
            </Container>
          </div>
        </Modal>
      );
    case 6:
      return (
        <Modal>
          <div className="modal-template">
            <p>We could not load your order. Please try again later.</p>
            <Container row jcsa margin="0em 0">
              <Button type={ButtonType.primary} onClick={() => window.location.reload()}>
                Refresh page
              </Button>
            </Container>
          </div>
        </Modal>
      );

    default:
      return <></>;
  }
};

export default ModalSwitcher;
